/**
 * Query key helpers for UnitControl feature
 * Centralizes query key construction for consistency and type safety
 */

export const amplifierKeys = {
  /**
   * Query key for a single amplifier by ID
   * @example ['amplifier', 'amp-123']
   */
  byId: (amplifierId: string) => ["amplifier", amplifierId] as const,

  /**
   * Query key for all amplifier queries (useful for invalidation)
   * @example ['amplifier']
   */
  all: () => ["amplifier"] as const,
}
